import { createClient } from '@connectrpc/connect';
import { ProfileAPI } from '@project-gd-x/dating-site-contracts/src/gen/gdx/gateway/web/profile/v1/profile_api_connect';
import {
  GetProfileRequest,
  GetProfileResponse,
  ListLikerProfilesRequest,
  ListLikerProfilesResponse,
  ListSoulmatesProfilesRequest,
  ListSoulmatesProfilesResponse,
  SearchRequest,
  SearchResponse,
  SkipProfileRequest,
  SkipProfileResponse,
} from '@project-gd-x/dating-site-contracts/src/gen/gdx/gateway/web/profile/v1/profile_api_pb';

import { getGrpcWebTransport } from '@/services/api/grpc-api';
import { ExtractClassFields } from '@/type';

const client = createClient(ProfileAPI, getGrpcWebTransport());

export function search(request: SearchRequest): Promise<SearchResponse> {
  return client.search(request);
}

export function getProfile(request: GetProfileRequest): Promise<GetProfileResponse> {
  return client.getProfile(request);
}

export function listLikerProfiles(
  request: ExtractClassFields<ListLikerProfilesRequest>,
): Promise<ListLikerProfilesResponse> {
  return client.listLikerProfiles(request);
}

export function skipProfile(userId: string): Promise<SkipProfileResponse> {
  const request = new SkipProfileRequest({
    userId,
  });

  return client.skipProfile(request);
}

function listSoulmatesProfiles(limitPerCategory: number): Promise<ListSoulmatesProfilesResponse> {
  const request = new ListSoulmatesProfilesRequest({
    limitPerCategory,
  });

  return client.listSoulmatesProfiles(request);
}

export const profileApi = {
  search,
  getProfile,
  listLikerProfiles,
  skipProfile,
  listSoulmatesProfiles,
};
